module.exports = __webpack_public_path__ + "img/hotstyleshow3.a7120dd3.jpg";